import Lucide from "../../base-components/Lucide";
import { useState, useEffect } from "react";
import WhatsappIcon from "../../assets/images/icon/Container.svg";
import Chats from "../CallLogChats";
import { RootState } from "src/stores";
import { connect } from "react-redux";
import chatIcon from "../../assets/images/chatIcons/CHAT.gif";

function Main({ messages }: any) {
  const [openChats, setOpenChats] = useState<boolean>(false);

  const [chatCount, setChatCount] = useState<any>(0);

  useEffect(() => {
    setChatCount(messages?.chatCount);
  }, [messages]);

  return (
    <div>
      <Chats isOpen={openChats} onClose={() => setOpenChats(false)} />
      <div
        onClick={(event: React.MouseEvent) => {
          event.preventDefault();
          setOpenChats(true);
        }}
        className="fixed -bottom-20 right-0 z-50 flex items-center justify-center mb-28 mr-5  rounded-full  cursor-pointer "
      >
        {chatCount > 0 && !openChats && (
          <div className="py-1 px-2.5 rounded-full bg-[#EF4444] text-white absolute -top-1 -right-1 z-10">
            {chatCount}
          </div>
        )}
        {/* <img src={WhatsappIcon} className="w-20 h-20" /> */}
        {/* <img src={chatIcon} className="w-20 h-20" alt="Chat Icon" />
                   */}
        <div className="relative w-16 h-16 rounded-full border border-primary/30 shadow-2xl bg-white flex items-center justify-center ml-[-5px]" style={{ transform: 'translateX(-12px)' }}>
          <img src={chatIcon} className="w-12 h-12 rounded-full border-1 " alt="Chat Icon" />
        </div>

        {/* <Lucide icon="MessageSquare" className="w-20 h-20" /> */}
      </div>
    </div>
  );
}

const mapStateToProps = ({ messages }: RootState) => ({
  messages: messages,
});

const mapDispatchToProps = (dispatch: any) => ({});
export default connect(mapStateToProps, mapDispatchToProps)(Main);
